'use strict'

export default (mockAxios) => {
  // TOPページの名刺表示件数設定を取得
  mockAxios.onGet(`/dcsettings`).reply(200, {
    'success': true,
    'data': {
      'top_row_bcard': 5,
      'top_row_stat': 5,
      'top_row_info': 5
    }
  })

  // TOPページの名刺表示件数設定を更新
  mockAxios.onPut(`/dcsettings`).reply(201, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/displaySettingRepositoryMock.js